import { Box, Button, CloseButton, Group, Stack, Text, Title } from '@mantine/core';
import { useMemo, useState } from 'react';

import { Batch, TransactionType, TransactionTypes } from '@e-origin/shared';

import { Select } from '@components';
import { useGenerateProformaB2BInvoice } from '@hooks/batch';
import { useTemplates } from '@hooks/useTemplates';

interface GenerateProformaB2BInvoiceProps {
  batch: Batch;
  onHide: () => void;
}

export const GenerateProformaB2BInvoice: React.FC<GenerateProformaB2BInvoiceProps> = ({ batch, onHide }) => {
  const [selectedTemplateId, setSelectedTemplateId] = useState<string>('');
  const { data: templatesList } = useTemplates();
  const generateProformaB2BInvoice = useGenerateProformaB2BInvoice();

  const filteredTemplates = useMemo(() => {
    return templatesList.filter((template) =>
      [TransactionTypes.B2B_HV, TransactionTypes.B2B_EXPORT].includes((template.transactionType as unknown as TransactionType)?.typeId),
    );
  }, [templatesList]);

  const templateOptions = useMemo(() => {
    return filteredTemplates.map((template) => ({
      value: template._id,
      label: template.name,
    }));
  }, [filteredTemplates]);

  const handleConfirm = async () => {
    if (selectedTemplateId) {
      onHide();
      await generateProformaB2BInvoice.mutateAsync({
        batchId: batch._id,
        templateId: selectedTemplateId,
      });
    }
  };

  return (
    <>
      <Group justify="space-between" align="center" p="lg">
        <Stack gap="xs">
          <Title order={4}>Generate Proforma B2B Invoice</Title>
          <Text>{batch.name}</Text>
        </Stack>
        <CloseButton onClick={onHide} />
      </Group>

      <Box p="lg">
        <Select
          label="Template"
          placeholder="Select a B2B-HV template"
          data={templateOptions}
          value={selectedTemplateId}
          onChange={(value) => setSelectedTemplateId(value || '')}
          searchable
          clearable
        />
      </Box>

      <Group justify="center" p="lg">
        <Button type="button" onClick={onHide} variant="outline" size="md">
          Cancel
        </Button>
        <Button type="button" onClick={handleConfirm} variant="filled" size="md" disabled={!selectedTemplateId}>
          Generate Invoice
        </Button>
      </Group>
    </>
  );
};
